import axios from 'axios';

const baseURL = process.env.REACT_APP_API_USUARIO + '/usuario';
const apiUserURL = process.env.REACT_APP_API_USUARIO;
const UserHerramienta = process.env.REACT_APP_NAMEAPP;

async function login({ username, password }) {
    const { data } = await axios.post(`${baseURL}/login`,
        { user: username, password: password, herramienta: UserHerramienta },
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });

    return data;
};

async function isLogged() {
    const { data } = await axios.post(`${baseURL}/islogged`,
        { herramienta: UserHerramienta },
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function logout() {
    const { data } = await axios.post(`${baseURL}/logout`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function getURLs() {
    const { data } = await axios.get(`${apiUserURL}/URL`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
}

export default { login, logout, isLogged, getURLs };

